import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=aae8a86c&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=aae8a86c&prod&lang=css&"
import style1 from "./Notice.vue?vue&type=style&index=1&id=aae8a86c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae8a86c",
  null
  
)

export default component.exports